<template>
  <div class="mani-page">
    <div class="header-container" v-show="$route.path != '/preview'">
      <div
        v-show="$route.path != '/preview'"
        :class="
          menuOpen ? 'label-header label-big ' : 'label-header label-small'
        "
      >
        <div class="logo-img">
          <img src="../../assets/img/logo2.png" alt="" />
        </div>
        <div class="header-detail">
          <div class="toggleIcon">
            <i class="el-icon-s-fold flodIcon" @click="toggleClick()"></i>
            <i class="el-icon-s-unfold openIcon" @click="toggleClick()"></i>
            <span class="company-name">鑫源全球客户服务管理平台</span>
          </div>
          <div class="topfix flex-right">
            <!-- <p @click="themeChange">切换 </p> -->
            <p class="time">{{ nowTime }}</p>
            <div
              v-if="roleList.indexOf('messageCenterList:get') !== -1"
              class="message-box"
            >
              <el-badge
                :hidden="$store.state.messageCount === 0"
                :value="$store.state.messageCount"
                :max="99"
              >
                <img
                  style="cursor: pointer"
                  class="message-icon"
                  src="@/assets/img/message.svg"
                  @click="handleMessage"
                />
              </el-badge>
            </div>
            <el-dropdown trigger="click" @command="handleCommand">
              <span style="cursor: pointer" class="el-dropdown-link">
                欢迎您！{{ name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="bindWechat" v-if="showBindWechat"
                  >绑定企业微信</el-dropdown-item
                >
                <el-dropdown-item command="a"> 个人信息</el-dropdown-item>
                <el-dropdown-item command="b">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="el-container">
      <Sidebar ref="sidebar" v-show="$route.path != '/preview'"></Sidebar>
      <div class="main-container">
        <bread
          v-show="$route.path != '/preview'"
          :class="menuOpen ? 'bread-menu-big' : 'bread-menu-small'"
        />
        <div
          :class="$store.state.mainScroll ? 'main-hidden' : 'main'"
          :style="
            $route.path == '/preview'
              ? 'top:0px;height: calc(100vh - 3px);'
              : ''
          "
        >
          <router-view></router-view>
          <!-- 我是内容区 -->
        </div>
      </div>
    </div>
    <div class="bind-wx-user-dialog-container">
      <el-dialog
        :visible.sync="bindWxUserDialogVisible"
        width="500px !important"
        title="绑定企业微信"
        :before-close="onCloseBindWxUserDialog"
      >
        <div class="abc">
          <div style="color: black">
            请登录企业微信，并点击<span style="color: blue"
              >继续在浏览器中登录访问</span
            >
            按钮
          </div>
          <div id="bind-wx-user-container" class="bind-wx-user-container"></div>
        </div>
      </el-dialog>
    </div>
    <!-- <switchTheme v-if="isDialog" :isDialog.sync="isDialog"></switchTheme> -->
  </div>
</template>
<script>
import bread from "@/components/breadMenu";
import * as moment from "moment";
import { logOut } from "@/api/api";
import collapse from "@/util/collapse";
import { setStorageNew, getSession } from "@/util/localStor";
// import { getNotReadMessageApi } from "@/api/seek";
import Sidebar from "../../components/Sidebar.vue";
// import switchTheme from "./theme.vue"
import {
  getUserBindCode,
  getUserBindWechatInfo,
  requestBindWechatInfo,
} from "../../api/api";
import { agentId, enterpriseId, wxLoginUrl } from "../../util/url";
import { problemListApi } from "@/api/feedback";
export default {
  components: {
    collapse,
    bread,
    Sidebar
  },
  data() {
    return {
      showBindWechat: false,
      wwLogin: undefined,
      bindWxUserDialogVisible: false,
      transform: "rotate(180deg)",
      transition: "all .3s",
      nowTime: "",
      name: "",
      currentId: "",
      currentMenu: "",
      showMenu: true,
      menuOpen: true,
      roleList: [],
      isDialog: false,
    };
  },
  watch: {
    $route(to, form) {
      this.currentId = this.$route.meta.id;
      this.currentMenu = this.$route.path;
      if (form.path == "/home" || to.path == "/home") {
        this.getWxProblemDetail();
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.getDates);
  },
  mounted() {
    this.checkCanBindWechat();
    this.getWxProblemDetail();
    this.name = sessionStorage.getItem("name");
    this.getData();
  },
  methods: {
    // 目录展开折叠
    toggleClick() {
      this.$refs.sidebar.isCollapse = !this.$refs.sidebar.isCollapse;
      if (this.$refs.sidebar.isCollapse == true) {
        $(".flodIcon").hide();
        $(".openIcon").show();
      } else {
        $(".flodIcon").show();
        $(".openIcon").hide();
      }
    },
    // 主题切换
    // themeChange() {
    //   this.isDialog = true;
    // },
    // 时间
    getData() {
      var date = moment().format("YYYY-MM-DD ");
      var time = moment().format(" HH:mm:ss ");
      this.nowTime = date + time;
      this.getDates = setTimeout(this.getData, 1000); // 递归时间
    },
    // 退出登录
    async logOut() {
      const res = await logOut();
      if (res.status == 0) {
        localStorage.clear();
        sessionStorage.clear();
        this.toLogin();
      }
    },
    toLogin() {
      sessionStorage.removeItem("token");
      this.$router.push("/login");
      this.$store.state.isLoading = false;
    },
    // 消息中心
    handleMessage() {
      this.$router.push("/messageCenter/list");
    },
    handleCommand(command) {
      if (command == "bindWechat") {
        this.bindWxUser();
        return;
      }
      if (command == "b") {
        this.logOut();
      } else {
        this.$router.push("/info");
      }
    },
    // 绑定企业微信
    checkCanBindWechat() {
      getUserBindWechatInfo().then((res) => {
        if (res.status == "0") {
          let hasBind = res.data;
          this.showBindWechat = !hasBind;
        }
      });
    },
    onCloseBindWxUserDialog() {
      if (this.wwLogin && this.wwLogin.unmount) {
        this.wwLogin.unmount();
      }
      this.wwLogin = null;
      this.bindWxUserDialogVisible = false;
    },
    bindWxUser() {
      getUserBindWechatInfo().then((res) => {
        if (res.status == "0") {
          let hasBind = res.data;
          if (!hasBind) {
            getUserBindCode().then((res) => {
              if (res.status == "0") {
                this.loginInWebBrowser(res.data);
              } else {
                this.$DonMessage.error("绑定失败！");
              }
            });
          } else {
            this.showBindWechat = false;
            this.$DonMessage.error("已绑定企业微信，无需再次绑定");
          }
        }
      });
    },
    loginInWebBrowser(bindCode) {
      let _this = this;
      this.bindWxUserDialogVisible = true;
      // 初始化登录组件
      setTimeout(() => {
        let redirectUrl = wxLoginUrl + "?bind_code=" + bindCode;
        this.wwLogin = ww.createWWLoginPanel({
          el: "#bind-wx-user-container",
          params: {
            login_type: "CorpApp",
            appid: enterpriseId,
            agentid: agentId,
            redirect_uri: redirectUrl,
            state: "loginState",
            //自行处理跳转
            redirect_type: "callback",
          },
          onCheckWeComLogin({ isWeComLogin }) {
            console.log(isWeComLogin);
          },
          onLoginSuccess({ code }) {
            let urlSearchParams = new URLSearchParams();
            urlSearchParams.append("wxCode", code);
            requestBindWechatInfo(urlSearchParams).then((res) => {
              if (res.status == "0") {
                _this.$DonMessage.error("绑定成功");
                _this.showBindWechat = false;
              } else {
                _this.$DonMessage.error(res.message);
              }
              _this.bindWxUserDialogVisible = false;
            });
          },
          onLoginFail(err) {
            _this.$DonMessage.error("绑定失败！");
            _this.bindWxUserDialogVisible = false;
          },
        });
      });
    },
    handlePage(data) {
      if (data.path == "") {
        this.$DonMessage.warning("开发中...");
      } else {
        this.$router.push(data.path);
        this.currentMenu = data.path;
      }
    },
    // 企业微信登录跳转
    getWxProblemDetail() {
      var hrefUrl = window.location.href;
      if (hrefUrl.includes("?")) {
        var params = hrefUrl.split("?")[1].substring(1).split("&");
        var paramsObj = {};
        params.forEach(function (param) {
          var [key, value] = param.split("=");
          paramsObj[decodeURIComponent(key)] = decodeURIComponent(value);
        });
        if (
          paramsObj.businessType == "qstBackManager" &&
          paramsObj.questionNum
        ) {
          var questionNum = paramsObj.questionNum;
          var param = {
            data: {
              questionNum: questionNum,
              feedbackFormId: "",
              countryId: "",
              taskStatus: "",
            },
            page: {
              pageNum: 1,
              pageSize: 10,
            },
          };
          let dataList = [];
          problemListApi(param).then((res) => {
            if (res.status === "0") {
              if (Array.isArray(res.data)) {
                dataList = res.data;
              } else {
                dataList = res.data?.records || [];
              }
              if (dataList.length > 0) {
                this.getLookDetail(dataList[0], param);
              } else {
                this.$DonMessage.warning("当前问题不存在");
              }
            }
          });
        }
      }
    },
    // 记录当前列表搜索条件
    recordSearchObj(param) {
      this.$router.replace(
        this.$route.path + "?searchObj=" + JSON.stringify(param)
      );
    },
    getLookDetail(data = {}, param) {
      localStorage.setItem("problemId", data.questionId);
      setStorageNew("problemData", data);
      localStorage.setItem("createTime", data.createTime);
      this.recordSearchObj(param);
      this.$nextTick(() => {
        this.$router.push({
          path: "/problemDetailNew/" + data.taskId,
          query: {
            questionNum: data.questionNum,
            searchObj: JSON.stringify(param),
          },
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.mani-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
// header
.header-container .label-header {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  height: 43px;
  background: var(--theme-color);
  padding: 0 20px 0 0px;
  transition: all 0.5s;
  ::v-deep .el-dropdown-menu {
    padding: 0 5px !important;
  }
}
/* logo */
.label-header .logo-img {
  width: 220px;
  height: 43px;
  background: linear-gradient(
    to right,
    var(--subMenu-color),
    var(--theme-color)
  );
  padding-left: 6px;
  overflow: hidden;
}
.label-header .logo-img img {
  height: 26px;
}
.label-header .logo-img,
.label-header .header-detail,
.label-header .toggleIcon {
  display: flex;
  align-items: center;
}
.label-header .header-detail {
  flex: 1;
  justify-content: space-between;
}
.label-header .toggleIcon i {
  color: #fff;
  font-size: 28px;
  vertical-align: middle;
  margin-top: 3px;
}
.toggleIcon .openIcon {
  display: none;
}
.company-name {
  font-size: 18px;
  margin-left: 10px;
  font-weight: bold;
}
.time {
  font-size: 12px;
  margin-right: 16px;
}
.el-dropdown {
  color: #fff;
}

// 内容
.el-container {
  height: calc(100vh - 43px);
}
.el-container > div {
  height: 100%;
}
.main-container {
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}
.main-container .main {
  height: calc(100vh - 83px);
  overflow: auto;
  background: var(--content-bgColor);
}
//滚动条设置
/* 设置滚动条的宽度 */
::-webkit-scrollbar {
  width: 5px; /* 垂直滚动条宽度 */
  height: 5px; /* 水平滚动条宽度 */
}

/* 设置滚动条轨道（背景）的颜色 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块（滑动部分）的颜色 */
::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 10px; /* 可选，设置圆角效果 */
}

/* 滑块在悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background: var(--theme-color); /* 悬停时滑块颜色 */
}
</style>
